<template>
  <div class="index_main center">

  
    <banner> </banner>

    <div v-for="item in list.getlist">
      {{ item.artist }}
    </div>
   

     <!-- <img src="/src/assets/images/share.png" alt="" style="width:20px;height:20px">
    <img src="/src/assets/images/sk.png" alt="" style="width:20px;height:20px"> -->

    <div class="nav_div">
      <ul>
        <li v-for="(item, index) in list.nav_div">
          <router-link to="" tag="a" @click.native="goitems(item.id)">
            <div>
              <img :src="item.img" />
            </div>
            <p>
              {{ item.title }}
            </p>
          </router-link>
        </li>
      </ul>
    </div>

    <div class="ft_main">
      <div class="main_title">
        飞天科技
      </div>
      <div class="main_about">
        <span>科技·创造·想象的理念，努力为树立行业旗帜而奋斗</span>
        <p>石家庄飞天科技开发有限公司致力于网站建设、</p>
        <p>微信营销、软件开发、品牌设计等服务。</p>
      </div>

      <div class="about_list">
        <p class="about_list_t"><我们的产品是这样出来的></p>
        <div>
          <ul>
            <li v-for="(item, index) in list.about_list">
              <div>
                <img :src="item.img" />
              </div>
              <p class="f14" :style="{ color: list.col[index].color }">
                {{ item.title }}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 客户案例 -->
    <div class="ft_main">
      <div class="main_title" v-html="list.success.title"></div>
      <div class="main_about">
        <span v-html="list.success.intro"></span>
      </div>
      <div class="case_list">
        <div style="text-align: left;">
          <ul>
            <li v-for="(item, index) in list.success.content" v-if="index < 4">
              <router-link to="" tag="a" @click.native="gocase(item.id)">
                <div class="img_div">
                  <img :src="item.img" />
                </div>
                <p
                  class="f14"
                  v-html="
                    item.name.length > 30
                      ? item.name.substring(0, 30) + '...'
                      : item.name
                  "
                  style="height: 36px;margin-left: 5px;"
                ></p>
                <span
                  class="f12 gray"
                  v-html="item.scene"
                  style="display:block;margin-top: 5px;margin-left: 5px;"
                ></span>
              </router-link>
            </li>
          </ul>
        </div>

        <div class="learnmore f14">
          <router-link :to="{ name: 'mecase' }" tag="a">
            更多案例
          </router-link>
        </div>
      </div>
    </div>

    <div class="ft_main">
      <div class="main_title" v-html="list.cooperation.title"></div>
      <div class="main_about">
        <span v-html="list.cooperation.intro"></span>
      </div>

      <div class="cooperation_list ">
        <div>
          <ul>
            <li v-for="item in list.cooperation.content">
              <div>
                <img :src="item" />
              </div>
            </li>
          </ul>
        </div>

        <div class="learnmore f14">
          <router-link :to="{ name: 'mecase' }" tag="a">
            更多案例
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wxapi from "../../public/wxapi.js"

export default {
  data() {
    return {
      list: {
        col: [
          { color: "#1dbfbf" },
          { color: "#ffba59" },
          { color: "#30a2f2" },
          { color: "#ea68a2" },
          { color: "#3981e6" },
          { color: "#ec6b71" }
        ],
        showHot: 1,
        id: "",

        getlist: [],
        nav_div: [
          {
            id: 3,
            img: require("@/assets/images/mo1.png"),
            img: require("@/assets/images/website.jpg"),
            title: "网站建设",
            site: "mefwxm"
          },
          {
            id: 4,
            img: require("@/assets/images/mo2.png"),
            img: require("@/assets/images/weixinlogo.jpg"),
            title: "微信营销",
            site: "mefwxm"
          },
          {
            id: 5,
            img: require("@/assets/images/mo3.png"),
            img: require("@/assets/images/APP.jpg"),
            title: "软件开发",
            site: "mefwxm"
          },
          {
            id: 6,
            img: require("@/assets/images/mo4.png"),
            img: require("@/assets/images/brand.jpg"),
            title: "品牌设计",
            site: "mefwxm"
          }
        ],
        about_list: [
          {
            id: 1,
            img: require("@/assets/images/lc_1.png"),
            title: "需求沟通",
            color: "#1dbfbf"
          },
          {
            id: 2,
            img: require("@/assets/images/lc_2.png"),
            title: "创意设计",
            color: "#ffba59"
          },
          {
            id: 3,
            img: require("@/assets/images/lc_3.png"),
            title: "前端制作",
            color: "#30a2f2"
          },
          {
            id: 4,
            img: require("@/assets/images/lc_4.png"),
            title: "技术开发",
            color: "#ea68a2"
          },
          {
            id: 5,
            img: require("@/assets/images/lc_5.png"),
            title: "测试调试",
            color: "#3981e6"
          },
          {
            id: 6,
            img: require("@/assets/images/lc_6.png"),
            title: "上线运行",
            color: "#ec6b71"
          }
        ],
        success: {
          content: []
        },

        cooperation: {
          title: "合作用户",
          intro: "提升品牌我们一直在努力，感谢您对我们的信任",
          site: "",
          content: [
            require("@/assets/images/cooperation/1.png"),
            require("@/assets/images/cooperation/2.png"),
            require("@/assets/images/cooperation/3.png"),
            require("@/assets/images/cooperation/4.png"),
            require("@/assets/images/cooperation/5.png"),
            require("@/assets/images/cooperation/6.png"),
            require("@/assets/images/cooperation/7.png"),
            require("@/assets/images/cooperation/8.png"),
            require("@/assets/images/cooperation/9.png"),
            require("@/assets/images/cooperation/10.png"),
            require("@/assets/images/cooperation/11.png"),
            require("@/assets/images/cooperation/12.png"),
            require("@/assets/images/cooperation/13.png"),
            require("@/assets/images/cooperation/14.png"),
            require("@/assets/images/cooperation/15.png"),
            require("@/assets/images/cooperation/16.png"),
            require("@/assets/images/cooperation/17.png"),
            require("@/assets/images/cooperation/18.png")
          ]
        }
      },
      items_tit: ""
    };
  },
  methods: {
    wxRegCallback() {
      // 用于微信JS-SDK回调
      this.wxShareTimeline();
      this.wxShareAppMessage();
    },
    wxShareTimeline() {
      // 微信自定义分享到朋友圈
      let option = {
        title: "石家庄飞天科技开发有限公司", // 分享标题, 请自行替换
        desc: "科技、创造、想象", // 分享描述, 请自行替换
        link: window.location.href, // 分享链接，根据自身项目决定是否需要split
        imgUrl: 'http://www.ftkj.net//storage/ueimage/20201023/1603417066384868.png', // 分享图标, 请自行替换，需要绝对路径
        success: () => {
          // alert("分享成功");
        },
        error: () => {
          // alert("已取消分享");
        }
      };
      // 将配置注入通用方法
      wxapi.ShareTimeline(option);
    },
    wxShareAppMessage() {
      // 微信自定义分享给朋友
      let option = {
        title: "石家庄飞天科技开发有限公司", // 分享标题, 请自行替换
        desc: "科技、创造、想象", // 分享描述, 请自行替换
        link: window.location.href, // 分享链接，根据自身项目决定是否需要split
        imgUrl: 'http://www.ftkj.net//storage/ueimage/20201023/1603417066384868.png', // 分享图标, 请自行替换，需要绝对路径
        success: () => {
          // alert("分享成功");
        },
        error: () => {
          // alert("已取消分享");
        }
      };
      // 将配置注入通用方法
      wxapi.ShareAppMessage(option);
    },
  
    async getcase() {
      var dt = await this.$axios.get("/api/index");
      dt.data = JSON.parse(dt.data);
      if (dt.status == 200) {
        if (dt.data.code !== 0) {
          this.$message({
            type: "info",
            message: dt.data.msg
          });
          return;
        }
      } else {
        alert(dt.statusText);
        return;
      }
      // console.log(dt.data.data)
      this.list.success = dt.data.data.success;
      // this.list.cooperation=dt.data.data.cooperation
    },

    gocase(val) {
      this.$router.push({
        name: "medetails",
        params: {
          id: val + ".html",
          casemenu: "2"
        }
      });
    },

    goitems(val) {
      this.$router.push({
        name: "meitems",
        params: {
          id: val + ".html"
        }
      });
    }
  },
  updated: function() {
    window.scroll(0, 0);
  },
  created: function() {
    this.getcase();
  },
  mounted() {
    wxapi.wxRegister(this.wxRegCallback);
  }
};
</script>

<style lang="less" scoped>
.index_main {
  overflow: hidden;
}

.nav_div {
  font-size: 14px;
  width: 100%;
  height: auto;
  margin-bottom: 10px;
  overflow: hidden;
  background: #fff;
  border-radius: 5px;

  ul {
    border-radius: 5px;
    li {
      /* flex: 1; */
      width: 25%;
      float: left;
      margin-top: 15px;
      padding: 5px 0;

      img {
        width: 50px;
      }

      p {
        padding: 10px 0;
        color: #333;
      }
    }
  }
}

.ft_main {
  /* padding: 10px; */
  margin-bottom: 10px;
  overflow: hidden;
  background: #fff;
  border-radius: 5px;

  .main_title {
    font-size: 18px;
    font-weight: bold;
    color: #e50012;
    padding: 20px 0;
    text-align: center;
    position: relative;
  }
  .main_title::after {
    content: "";
    display: block;
    position: absolute;
    width: 10%;
    left: 45%;
    height: 2px;
    background: #e50012;
    bottom: 10px;
  }

  .main_about {
    span {
      text-align: center;
      font-size: 10px;
      color: #999;
      display: block;
      margin-bottom: 15px;
    }
    p {
      text-align: center;
      font-size: 14px;
      margin: 6px;
    }
  }

  /* 关于飞天 */
  .about_list {
    background: #f2f2f2;
    margin: 20px 10px 10px;
    border-radius: 5px;
    padding-bottom: 5px;
    overflow: hidden;

    .about_list_t {
      color: #e50012;
      padding: 20px 0px;
      font-size: 15px;
      text-align: center;
      font-weight: bold;
    }

    li {
      width: 33.3%;
      float: left;
      overflow: hidden;

      div {
        margin: 0 auto;
        width: 40px;

        img {
          width: 100%;
        }
      }

      p {
        padding: 10px 0;
      }
    }
  }

  /* 成功案例 */
  .case_list {
    overflow: hidden;
    background: transparent;

    div {
      overflow: hidden;

      li {
        width: 48%;
        margin: 10px 1%;
        float: left;

        @media (max-width: 480px) {
          .img_div {
            height: 120px;
          }
        }

        @media (min-width: 480px) and (max-width: 2000px) {
          .img_div {
            height: 200px;
          }
        }

        .img_div {
          border-radius: 5px;
          border: 5px solid #fff;
          overflow: hidden;
          box-sizing: border-box;
          box-shadow: 0 2px 5px 0 #c9c9c9;

          img {
            width: 100%;
          }
        }

        p {
          padding: 10px 0 0;
        }
      }
    }
  }
  /*合作用户*/
  .cooperation_list {
    overflow: hidden;

    div {
      overflow: hidden;

      li {
        width: 31%;
        margin: 10px 1%;
        float: left;

        img {
          width: 100%;
        }
      }
    }
  }

  .learnmore {
    a {
      padding: 10px 20px;
      background: #e50012;
      color: #fff;
      border-radius: 20px;
    }
  }
}

.active {
  color: rgb(229, 72, 71);
  border-bottom: 2px solid rgb(229, 72, 71);
}
</style>



// WEBPACK FOOTER //
// src/components/move/index.vue